<template>
  <div
    :dir="currentTextDirection"
    class="mainBox col-md-12 pa-0 position-relative"
  >
          <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="data.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="data?.identifier || ''"
          :profile-avatar="data.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <component
      :is="components[data?.photo?.transition || 'scale']"
      mode="out-in"
      origin="center"
    >
      <!-- Welcome Screen -->
      <div
        v-if="showWelcome && data.photo?.hasWelcome"
        key="loading"
        class="col-md-11 mx-auto d-flex"
        style="min-height: 75vh"
      >
        <div v-if="data.photo.welcome === ''" class="col m-auto">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </div>

        <div v-if="data.photo.welcome !== ''" class="m-auto">
          <img
            :src="data.photo.welcome"
            alt=""
            class="bg-white img-fluid rounded-circle mx-auto my-auto"
            width="100"
          />
        </div>
      </div>

      <!--previewer -->
      <!-- <component
        :is="components[data?.photo?.previewerQr?.transition || 'scale']"
        mode="out-in"
        origin="center"
      > -->
      <!-- previewerQr Screen - GIF Preview -->
      <!-- <div
          v-if="showPreviewer && data.photo.previewerQr.previewer.gif"
          key="gif-preview"
          class="col-md-11 mx-auto d-flex"
          style="min-height: 75vh; display: flex !important"
        >
          <div class="m-auto position-relative" style="max-width: 240px">
            <v-btn
              class="position-absolute"
              :class="
                isCurrentLangRTL
                  ? 'top-0 start-0 ms-2 mt-2'
                  : 'top-0 end-0 me-2 mt-2'
              "
              color="error"
              icon
              @click="showPreviewer = false"
              style="
                z-index: 10;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 50%;
              "
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
            <v-img
              :src="data?.photo?.previewerQr?.previewer?.gif"
              alt="خوش آمدگویی"
              class="bg-white img-fluid mx-auto my-auto"
              width="240"
              :style="{
                borderRadius:
                  (data.photo.previewerQr.gifBorderRadius || 0) + 'px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              }"
            />
          </div>
        </div> -->
      <!-- Location Page -->
      <div
        v-if="locationPage && data.coordinates && data.coordianates[0]"
        key="location"
        class="col-md-12"
      >
        <v-card-title class="px-0 pt-0 justify-end">
          <v-btn
            class="mx-2 mr-auto text-left"
            color="white"
            small
            @click="locationPage = false"
          >
            {{ localI18n.t("back") }}
            <v-icon class="ms-2" color="black">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-card-title>

        <div>
          <p>
            <span class="fa fa-car ml-1 text-danger"></span>
            {{ localI18n.t("after_click_location") }}
          </p>

          <v-card
            v-if="locLoading"
            class="d-flex align-center justify-center"
            flat
            height="400"
            width="100%"
          >
            <atom-spinner
              :animation-duration="1000"
              :size="120"
              class="mx-auto justify-content-center"
              color="#ff1d5e"
            />
          </v-card>

          <mapir
            :apiKey="data.apiKey"
            :center="data.coordinates"
            :zoom="17"
            class="col-md-12"
            style="width: 100%; height: 400px"
            @click.self="openMap"
          >
            <mapNavigationControl position="top-right" />
            <mapMarker
              :coordinates.sync="data.coordinates"
              color="red"
              kind="marker"
              readonly
            >
              <template v-slot:marker>
                <v-icon>mdi-map-marker</v-icon>
              </template>
            </mapMarker>
          </mapir>
        </div>

        <div class="col-md-12 flex py-2 my-3">
          <p>
            <span><v-icon color="red">mdi-map-marker</v-icon></span>
            {{ data.address }}
          </p>
        </div>
      </div>
      <!-- Welcome Image Preview -->
      <div
        v-else-if="showWelcome && data.photo?.welcome"
        key="welcome"
        class="col-md-11 mx-auto d-flex"
        style="min-height: 75vh"
      >
        <div
          v-if="data.photo.welcome === '' || data.photo.welcome === null"
          class="col m-auto"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </div>

        <div v-else class="m-auto">
          <img
            :src="data.photo.welcome"
            alt=""
            class="bg-white img-fluid rounded-circle mx-auto my-auto"
            width="100"
          />
        </div>
      </div>
      <!-- Main Visit Card - Only shown when no preview is active -->
      <div v-else key="visitCard" style="padding: 28px 0 0 0">
        <!-- Header -->

        <v-responsive
          :aspect-ratio="1.592"
          :class="{ 'has-bg-head': data.photo?.headBackground }"
          :style="{
            background: getHeaderBg,
            'flex-direction': pageDirection === 'ltr' ? 'row-reverse' : 'row',
          }"
          class="col-md-11 col-12 text-center d-flex justify-content-center mx-auto headBox mt-n5"
        >
          <v-card
            class="transparent d-flex flex-column justify-center align-center"
            flat
            height="100%"
            width="100%"
          >
            <div
              v-if="data.photo?.profile"
              key="logo"
              class="white rounded-circle header-img-bg"
            >
              <div
                :style="{ backgroundImage: `url(${data.photo.profile})` }"
                class="bg-filter"
              />
              <img :src="data.photo.profile" alt="" />
            </div>

            <div v-else class="ma-auto" style="width: 100px; height: 100px" />
            <h6
              :style="{
                color: data.pallete?.textColor
                  ? data?.pallete?.textColor
                  : 'white',
              }"
              class="mt-4 font-weight-bold"
            >
              {{ data.organizationName }}
            </h6>
            <p
              :style="{
                color: data.pallete?.textColor
                  ? data?.pallete?.textColor
                  : 'white',
              }"
              class="mb-6"
            >
              {{ data.subOrgan }}
            </p>
          </v-card>
        </v-responsive>

        <!-- Action Buttons -->
        <v-row
          :style="{ background: data.pallete?.headColor }"
          class="mt-n5 py-0 callBox px-4 col-md-9 col-10 mx-auto px-md-1"
          justify="center"
          no-gutters
        >
          <v-col v-if="data.companyNumber" class="text-center" cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :href="`tel:${data.companyNumber}`"
                  class="mx-2"
                  color="white"
                  fab
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>{{
                data.companyNumberName || localI18n.t("phone_number")
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col v-if="availableLangs.length > 1" class="text-center" cols="2">
            <languageswitcherpopup
              v-model="showLangSwitcher"
              @source-changed="internalLangChange"
              :currentLang="currentLang"
                :headColor="data.pallete.headColor"

            />
          </v-col>

          <v-col
            v-if="data.coordinates && data.coordinates[0]"
            class="text-center"
            cols="3"
          >
            <v-btn
              class="mx-2"
              dark
              fab
              icon
              small
              @click="locationPage = true"
            >
              <v-icon color="white">mdi-map-marker</v-icon>
            </v-btn>
          </v-col>

          <v-col class="text-center" cols="2" v-if="data?.customerClub && (data.customerClub.configs?.isActive || data.customerClub.title?.trim() || data.customerClub.description?.trim())">
            <v-tooltip 
              :value="
                data.advanceSettings &&
                data.advanceSettings.viewConfigs.showCClubOnload
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2"
                  dark
                  fab
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="show"
                >
                  <v-icon>mdi-card-account-phone-outline</v-icon>
                </v-btn>
              </template>
              <span>{{
                data.advanceSettings &&
                data.advanceSettings.viewConfigs.showCClubOnload
                  ? localI18n.t("auto_display")
                  : localI18n.t("customer_club")
              }}</span>
            </v-tooltip>
          </v-col>
          <v-col
            v-if="
                  (data?.phoneNumber && Array.isArray(data.phoneNumber) &&
                    data?.phoneNumber?.length > 0 &&
                    data?.phoneNumber?.[0]?.number) ||
                  data?.companyNumber
            "
            class="text-center"
            cols="2"
          >
            <v-tooltip
              :value="
                data.advanceSettings &&
                data.advanceSettings.viewConfigs.autoCsvDownload
              "
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :loading="vcfLoading"
                  class="mx-2"
                  dark
                  fab
                  icon
                  small
                  v-bind="attrs"
                  @click="getVcf"
                  v-on="on"
                >
                  <v-icon color="white">mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{
                data.advanceSettings &&
                data.advanceSettings.viewConfigs.autoCsvDownload
                  ? localI18n.t("auto_download")
                  : localI18n.t("save")
              }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <!-- Content List -->
        <div
          class="col-md-12 pt-3 custom-scrollbar px-0"
          :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
          style="min-height: 400px; max-height: 400px; overflow-y: auto"
        >
          <div
            class="col-md-11 mx-auto py-4 mb-5"
            :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
          >
            <drag-list v-model="draggingKeys">
              <template v-slot:default="{ item }">
                <!-- userName -->
                <template v-if="item === 'userName'">
                  <p
                    v-if="data.userName"
                    class="my-2"
                    :dir="getTextDirectionFromContent(data.userName)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.userName),
                    }"
                  >
                    <v-icon>mdi-account-outline</v-icon>
                    : {{ data.userName }}
                  </p>
                </template>

                <!-- workField -->
                <template v-if="item === 'workField'">
                  <p
                    v-if="data.workField"
                    class="my-2"
                    :dir="getTextDirectionFromContent(data.workField)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.workField),
                    }"
                  >
                    <v-icon>mdi-briefcase-account</v-icon>
                    : {{ data.workField }}
                  </p>
                </template>

                <!-- aboutUs -->
                <template v-if="item === 'aboutUs'">
                  <div
                    v-if="data.aboutUs"
                    class="my-2"
                    :dir="getTextDirectionFromContent(data.aboutUs)"
                    :style="{
                      textAlign: getTextAlignFromContent(data.aboutUs),
                    }"
                  >
                    <span><v-icon>mdi-comment-account-outline</v-icon></span>
                    :
                    <span class="font-weight-bolder">{{
                      localI18n.t("about_us")
                    }}</span>
                    <div class="col-md-12 mb-2">
                      <pre
                        class="my-0"
                        :dir="getTextDirectionFromContent(data.aboutUs)"
                        :style="{
                          textAlign: getTextAlignFromContent(data.aboutUs),
                        }"
                        v-html="trancateTxts"
                      />
                      <v-btn
                        v-if="
                          data.aboutUs.length > 200 ||
                          data.aboutUs.split('<div>').length > 3
                        "
                        class="ms-n4"
                        color="primary"
                        text
                        @click="isTruncate = !isTruncate"
                      >
                        {{
                          isTruncate
                            ? localI18n.t("view_more")
                            : localI18n.t("view_less")
                        }}
                      </v-btn>
                    </div>
                  </div>
                </template>


                <!-- video_single -->
                <template v-if="item === 'video_single' && !!data.video_single">
                  <v-card
                    v-for="(v, indx_1) in data.video_single.videos"
                    :key="`${indx_1}_1`"
                    class="transparent"
                    flat
                    :dir="getTextDirectionFromContent(p.text || '')"
                    :style="{
                      textAlign: getTextAlignFromContent(p.text || ''),
                    }"
                    style="max-width: 100%"
                  >
                    <v-card-title
                      :class="{ 'blue--text clickable': v.link }"
                      :href="fixLink(v.link)"
                      :tag="v.link ? 'a' : 'div'"
                      class="pa-2 text-break"
                      target="_blank"
                      v-text="v.title"
                    />
                    <video
                      v-if="isDirectVideo(v.url)"
                      :src="v.url"
                      controls
                      style="max-width: 100%; height: auto; width: 100%;"
                    ></video>

                    <iframe
                      v-else
                      :src="v.url"
                      style="max-width: 100%; height: auto; width: 100%;"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>

                    <pre v-html="v.description" />
                  </v-card>
                </template>

                <!-- video_gallery -->
                <div
                  v-if="item === 'video_gallery' && !!data.video_gallery"
                  class="d-flex flex-column"
                >
                  <div
                    v-for="(src, i) in data.video_gallery[0].images"
                    :key="i"
                  >
                    <v-card-title
                      :href="!!src.link ? src.link : null"
                      :tag="!!src.link ? 'a' : 'div'"
                      class="pa-2"
                      :dir="getTextDirectionFromContent(src.title || '')"
                      :style="{
                        textAlign: getTextAlignFromContent(src.title || ''),
                      }"
                      target="_blank"
                      v-html="src.title"
                    />
                    <video
                      v-if="isDirectVideo(src.url || src.file_link)"
                      :src="src.url || src.file_link"
                      controls
                      style="max-width: 100%; height: auto; width: 100%;"
                    ></video>

                    <iframe
                      v-else
                      :src="src.url || src.file_link"
                      style="max-width: 100%; height: auto; width: 100%;"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                    <v-card-text
                      v-show="!!src.description"
                      v-html="src.description"
                      :dir="getTextDirectionFromContent(src.description || '')"
                      :style="{
                        textAlign: getTextAlignFromContent(
                          src.description || '',
                        ),
                      }"
                    />
                  </div>
                </div>

                <!-- photo -->
                <template v-if="item === 'photo'">
                  <div style="max-width: calc(100% - 24px)" v-if="data?.photo?.gallery" :style="{
                                  'flex-direction': pageDirection === 'ltr' ? 'row-reverse' : 'row',
                                }"
                      >

                    <image-slider
                      v-model="data.photo.gallery"
                      :orientation="resolvedOrientation"
                      :is-slider="resolvedIsSlider"
                    />                                                    
                </div>
                </template>
               <!-- pdfSection -->
                <template v-if="item === 'pdf'">
                  <div v-if="data?.pdf && data?.pdf?.length > 0" class="box">
                      <pdf-preview-display
                        :pdf-data="data.pdf"
                        :layout-mode="layoutPreference"
                        :pdf-selector="data.pdfSelector"
                        :current-lang="currentLang"
                        :lang="currentLang"                     
                         />
                    </div>
                </template>
                <!--consultation-->
                <template v-if="item==='consultation'">
                  <consultation-new-show class="box pa-0 ma-0"
                    :style="{
                      background: data.consultationNew?.sectionColor?.backGround,
                      color: data.consultationNew?.sectionColor?.text,
                    }"
                    :color="data.consultationNew?.sectionColor?.text"
                    v-model="data.consultationNew"
                    :current-lang="currentLang"
                    :lang="currentLang"
                  />
                </template>
                <!--feedback-->
                <template v-if="item==='FeedBack'">
                  <b-feedback-view 
                      v-if="data.FeedBack && data.FeedBack.items.length > 0"
                      v-model="data.FeedBack"
                      :current-lang="currentLang"
                      :lang="currentLang"
                  />
                </template>

                <!-- extraFields -->
                <template v-if="item === 'extraFields'">
                  <extra-shown v-model="data.extraFields" />
                </template>

                <!-- phoneNumber -->
                <template v-if="item === 'phoneNumber' && data?.phoneNumber?.length>0
">
                  <div
                    :key="`${item.name}--6`"
                  >
                    <p
                      v-for="(phone, phoneIndex) in data?.phoneNumber"
                      :key="phoneIndex"
                      class="text-right my-2"

                    >
                      <v-icon color="red">mdi-phone-outline</v-icon>
                      <span>:  </span>
                      <span v-if="phone?.text">{{ phone?.text }} </span>
                      <a
                        :href="`tel:${
                          phone?.number?.startsWith('+') ? '' : '+'
                        }${phone?.number?.replace(/[^\d]/g, '')}`"
                        class="link-tag clickable mx-1 align-center justify-end"
                        target="_blank"
                        dir="ltr"
                        style="display: inline-line; direction: ltr !important"
                      >
                        {{ phone?.number }}
                      </a>
                      <span> {{ phone?.number?.replace(/[\d\^+]/g, "") }}</span>
                     
                    </p>
                  </div>
                </template>

                <!-- fax -->
                <template v-if="item === 'fax'">
                  <p
                    v-if="data.fax"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                  >
                    <v-icon>mdi-fax</v-icon>
                    : {{ data.fax }}
                  </p>
                </template>

                <!-- location -->
                <template v-if="item === 'location'">
                  <div
                    :dir="getTextDirectionFromContent(data.location || '')"
                    :style="{
                      textAlign: getTextAlignFromContent(data.location || ''),
                    }"
                  >
                    <pre
                      v-if="data.location"
                      class="d-flex justify-start align-start my-2"
                      :class="
                        getTextDirectionFromContent(data.location) === 'rtl'
                          ? 'justify-start'
                          : 'justify-start'
                      "
                    >
                      <v-icon>mdi-map-marker</v-icon>: {{ data.location }}
                    </pre>
                  </div>
                </template>

                <!-- codePostal -->
                <template v-if="item === 'codePostal'">
                  <p
                    v-if="data.codePostal"
                    class="my-2"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                  >
                    <v-icon>mdi-post</v-icon>
                    : {{ data.codePostal }}
                  </p>
                </template>

                <!-- audio_ -->
                <template
                  v-if="
                    item?.startsWith('audio_') &&
                    data?.audiosGallery?.audios?.length > 0
                  "
                >
                  <v-col cols="12">
                    <v-card
                      v-if="
                        data?.audiosGallery &&
                        data?.audiosGallery?.audios.length > 0
                      "
                      width="300"
                      height="auto"
                      :style="{ background: getAudioById(item)?.background }"
                      class="pa-0 my-2 d-flex align-items-center flex-column"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <v-card-title
                        :style="{ color: getAudioById(item)?.color }"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                        v-if="getAudioById(item)?.ti?.length > 0"
                        >{{ getAudioById(item)?.ti }}</v-card-title
                      >
                      <v-card-subtitle
                        :style="{ color: getAudioById(item)?.color }"
                        :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                        class="pa-0"
                        v-if="getAudioById(item)?.desc?.length > 0"
                        >{{ getAudioById(item)?.desc }}</v-card-subtitle
                      >
                      <component
                        v-if="
                          data?.audiosGallery && data.audiosGallery.audioType
                        "
                        :is="data.audiosGallery.audioType"
                        :file="getAudioById(item).full_path"
                        :link="false"
                        :inf="{
                          ti: getAudioById(item)?.ti,
                          link: getAudioById(item)?.link,
                          title: getAudioById(item)?.title,
                          desc: getAudioById(item)?.desc,
                        }"
                        :image="getAudioById(item)?.image"
                        :title="
                          getAudioById(item)?.title?.length > 0
                            ? getAudioById(item)?.title
                            : localI18n.t('audio_file')
                        "
                        width="100%"
                        :height="
                          data.audiosGallery.audioType == 'newPlayer'
                            ? 280
                            : 150
                        "
                        :flat="true"
                        :audioSound="false"
                        :color="getAudioById(item)?.color"
                        background="transparent"
                        :auto-play="item.autoPlay"
                      />
                    </v-card>
                  </v-col>
                </template>

                <!-- email -->
                <template v-if="item === 'email'">
                  <a :href="`mailto:${data.email}`" target="_blank">
                    <p
                      v-if="data.email"
                      class="my-2 clickable link-tag"
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <span
                        ><v-icon color="red">mdi-email-outline</v-icon></span
                      >
                      : {{ data.email }}
                    </p>
                  </a>
                </template>

                <!-- website -->
                <template v-if="item === 'website'">
                  <p
                    v-if="data.website"
                    class="my-3 clickable link-tag"
                    :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    @click="goToUrl(data.website)"
                  >
                    <span><v-icon color="blue">mdi-earth</v-icon></span> :
                    {{ data.website }}
                  </p>
                </template>
              </template>
            </drag-list>
          </div>
        </div>

        <!-- Footer -->
        <div
          :style="{ background: data.pallete?.bodyColor }"
          class="col-md-11 col-11 mx-auto footerBox text-center justify-content-center position-absolute pa-md-3 pa-2"
          :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
        >
          <v-row justify="center" no-gutters>
            <v-col v-for="(item, index) in thirdOne" :key="index" cols="3">
              <v-btn icon @click="goToUrl(item.url, item.pattern)">
                <img :src="item?.img" :alt="item?.label" loading="lazy" 
                    :height="item?.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item?.svg) ? '29px' : '32px'"
                    :width="item?.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item?.svg) ? '29px' : '32px'" />
              </v-btn>
            </v-col>

            <v-col v-if="computeFields.length > 0" cols="3">
              <v-menu
                class="overflow-y-auto"
                nudge-top="40"
                :right="isCurrentLangRTL"
                :left="!isCurrentLangRTL"
                style="max-height: 30px !important"
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    :right="isCurrentLangRTL"
                    :left="!isCurrentLangRTL"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="white" size="28">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list
                  :style="{ background: data.pallete?.bodyColor }"
                  dark
                  min-width="150"
                >
                  <v-list-item
                    v-for="(item, index) in computeFields"
                    :key="index"
                    link
                    @click="goToUrl(item.url, item.pattern)"
                  >
                    <v-list-item-icon>
                      <v-btn dark icon>
                        <img :src="item?.img" :alt="item?.label" loading="lazy"  class="img-fluid"
                              :height="item?.svg.toLowerCase()==='svgbasalam'? '22px': isBigSvg(item?.svg) ? '29px' : '32px'"
                              :width="item?.svg.toLowerCase()==='svgbasalam'? '22px':isBigSvg(item?.svg) ? '29px' : '32px'" />
                      </v-btn>
                    </v-list-item-icon>
                    <v-list-item-content
                      :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
                    >
                      <v-list-item-title
                        v-text="item.label"
                        :dir="getTextDirectionFromContent(item?.label)"
                        :style="{
                          textAlign: getTextAlignFromContent(item?.label),
                        }"
                      />
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </div>
      </div>
    </component>
    <!-- </component> -->
    <assistant-chat-viewer
      v-if="
        !!data.advanceSettings?.hasAssistants &&
        !!data.advanceSettings?.aiChatConfig?.assistantId
      "
      :aiChatConfig="data.advanceSettings.aiChatConfig"
    />
    <!-- <game-modal
      v-model="showGameModal"
      :game="selectedGame"
      @close="showGameModal = false"
    />
    <PhoneFrame
      v-if="showPreviewDialog"
      v-model="showPreviewDialog"
      :background-image="
        data.photo?.previewerQr?.previewer?.game?.config?.images
          ?.phoneFrameBackground
      "
    >
      <Game
        :key="previewKey"
        v-if="showPreviewDialog && gameName === 'Game'"
        :value="data.photo.previewerQr.previewer.game.config"
        @gameover="onPreviewGameOver"
        @submit-score="onGameScoreSubmit"
      />
      <MeepMeepProRunner
        v-if="showPreviewDialog && gameName === 'MeepMeepProRunner'"
        :value="data.photo.previewerQr.previewer.game.config"
        @submit-score="onGameScoreSubmit"
      />
    </PhoneFrame> -->
  </div>
</template>

<script>
// import languageswitcherpopup from "./languageswitcherpopup.vue";
import gameModal from "../../../components/game/gameModal.vue";
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplayCell_multilang";
import ConsultationNewShow from "../../../components/consultationNew/consultationNewShowCell_multilang.vue";
import BFeedbackView from "../../businessPage/components/view/bFeedbackView_mulilang.vue";
import {
  textDirectionMixin,
  detectLanguage,
  getTextAlign,
} from "@/utilities/textDirection";
import { Bus, debounce } from "@/main";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";
import ImageSlider from "../../../components/Gallery/imageSlider.vue";
import ExtraShown from "../../../components/Product/extraShown.vue";
import DragList from "../dragList";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import AudioPlayer from "../../../components/UploadCenter/voiceGallery/components/audioPlayer.vue";
import AudioPlayerCard from "../../../components/UploadCenter/voiceGallery/components/audio/audioPlayerCard.vue";
import newPlayer from "../../../components/UploadCenter/voiceGallery/components/audio/newPlayer.vue";
import newPlayer2 from "../../../components/UploadCenter/voiceGallery/components/audio/newPlayer2.vue";
import { mapGetters, mapActions } from "vuex";
import localI18n from "../../../../i18n_local_cardvisit";
// import { QrDataFormatter } from "@/utilities/qrDataFormatter";
import Languageswitcherpopup from "./languageswitcherpopup.vue";
import assistantChatViewer from "./assistantChatViewer.vue";
import PhoneFrame from "@/view/components/game/publicGame/phoneFrame.vue";
import Game from "@/view/components/game/publicGame/game.vue";
import MeepMeepProRunner from "../../../components/game/publicGame/MeepMeepProRunner.vue";
import UniversalQrModal from "../../../components/UniversalQrModal.vue";

export default {
  name: "mobileViwer",

  components: {
    DragList,
    ExtraShown,
    ImageSlider,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
    AtomSpinner,
    AudioPlayer,
    AudioPlayerCard,
    newPlayer,
    newPlayer2,
    VFadeTransition,
    VScaleTransition,
    VSlideXTransition,
    VSlideYTransition,
    Languageswitcherpopup,
    assistantChatViewer,
    gameModal,
    Game,
    PhoneFrame,
    MeepMeepProRunner,
    BFeedbackView,
    ConsultationNewShow,
    PdfPreviewDisplay,
    UniversalQrModal,
  },

  mixins: [textDirectionMixin],

  props: {
    value: Object,
    orders: Array,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },

  },

  data() {
    return {
      showQrDialog:false,
      showPreviewDialog: false,
      gameName: "",
      previewKey: Date.now(),
      showGameModal: false,
      selectedGame: null,
      localI18n,
      showLangSwitcher: false,
      currentLang: "fa",
      langDataCache: {},
      showconncet: false,
      locLoading: false,
      isTruncate: true,
      locationPage: false,
      showWelcome: false,
      showPreviewer: false,
      vcfLoading: false,
      components: {
        scale: VScaleTransition,
        slideX: VSlideXTransition,
        slideY: VSlideYTransition,
        fade: VFadeTransition,
      },
    };
  },

  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
      "currentlanguage",
    ]),
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    resolvedIsSlider() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.slider != null
    ) {
      return photoPicSelector.slider;
    }

    if (
      mainPicSelector &&
      mainPicSelector.slider != null
    ) {
      return mainPicSelector.slider;
    }

    return true;
  },

  resolvedOrientation() {
    var photoPicSelector =
      this.data &&
      this.data.photo &&
      this.data.photo.PicSelector;

    var mainPicSelector =
      this.data &&
      this.data.PicSelector;

    if (
      photoPicSelector &&
      photoPicSelector.orientation != null
    ) {
      return photoPicSelector.orientation;
    }

    if (
      mainPicSelector &&
      mainPicSelector.orientation != null
    ) {
      return mainPicSelector.orientation;
    }

    return "horizontal";
  },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },
    isCurrentLangRTL() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.isRTL(lang);
    },
    pageDirection() {
      return this.getTextDirection(this.currentlanguage);
    },
    pageDirectionClass() {
      return `direction-${this.pageDirection}`;
    },

    currentTextDirection() {
      const lang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return this.getTextDirection(lang);
    },

    data: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    sourceLanguage() {
      return this.defaultLang || "fa";
    },

    availableLangs() {
      const defaultLang = this.defaultLang || "fa";
      const extraLangs = Array.isArray(this.alllangs) ? this.alllangs : [];
      return [defaultLang, ...extraLangs]
        .filter((lang) => lang && typeof lang === "string")
        .filter((lang, idx, arr) => arr.indexOf(lang) === idx);
    },

    thirdOne() {
      this.currentLang;
      this.data?.photo?.transition;
      this.data?.socialMedia;

      let top = {};
      Object.entries(this.data.socialMedia || {})
        .slice(0, 3)
        .forEach(([x, y]) => {
          top[x] = y[0];
        });
      return top;
    },

    computeFields() {
      this.currentLang;
      this.data?.photo?.transition;
      this.data?.socialMedia;
      let extra = [];
      Object.entries(this.data.socialMedia || {}).forEach(([_, y]) => {
        extra.push(...y);
      });
      Object.values(this.thirdOne).forEach((x) => {
        extra = extra.filter((item) => item !== x);
      });
      return extra;
    },

    trancateTxts() {
      this.currentLang;
      this.data?.photo?.transition;
      this.data?.socialMedia;
      let about = this.data.aboutUs || "";

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
    },

    getHeaderBg() {
      this.currentLang;
      this.data?.photo?.transition;
      this.data?.socialMedia;
      return this.data.photo?.headBackground &&
        this.data.photo.headBackground.length > 0
        ? `url('${this.data.photo.headBackground}')`
        : this.data.pallete?.headColor ||
            "linear-gradient(to top, #AA7630FF, #EBCB63FF)";
    },

    draggingKeys: {
      get() {
        return this.orders;
      },
      set(val) {
        this.$emit("update:orders", val);
      },
    },
  },

  watch: {
    currentlanguage: {
      handler(lang) {
        this.changeLanguage(lang);
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
    "data.langs": {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
    // currentLang: {
    //   handler() {
    //     this.$forceUpdate();
    //   },
    // },
    "$i18n.locale"(newLocale) {
      const hasLocalLang = this.data.langs?.other_langs?.some(
        (l) => l.lang === this.currentLang,
      );
      if (!hasLocalLang) {
        this.changeLanguage(newLocale);
      }
    },
    // orders: {
    //   deep: true,
    //   handler(newOrders) {
    //     this.$root.$emit("mobile-viewer-updated", {
    //       orders: newOrders,
    //       lang: this.currentLang,
    //     });
    //   },
    // },
    // value: {
    //   deep: true,
    //   handler(newData) {
    //     this.$root.$emit("mobile-viewer-updated", {
    //       data: newData,
    //       lang: this.currentLang,
    //     });
    //   },
    // },
    // data: {
    //   deep: true,
    //   handler(val) {
    //     this.cacheCurrentData();
    //     this.setKeys();
    //     debounce(() => {
    //       this.setKeys(val);
    //     }, 1300);
    //   },
    // },

    locationPage(val) {
      if (val) {
        this.locLoading = true;
        this.getlatLng();
      }
    },
  },

  created() {
    // this.$root.$on("mobile-viewer-lang-change", (lang) => {
    //   this.changeLanguage(lang);
    //   this.$forceUpdate();
    // });
    // this.setCurrentLanguage(this.defaultLang);

    this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      if (this.currentLang === lang) {
        this.applyLangData(lang, data);
      }
    });
    this.$root.$on("fetchDragList", this.setKeys);
    //  this.syncInitialLang();
  },

  mounted() {
    Bus.$on("preview-game-in-mobile", (payload) => {
      this.selectedGame = payload.game;
      this.showGameModal = true;
    });
    Bus.$on("open-game-modal", (payload) => {
      this.selectedGame = payload.game;
      if (this.selectedGame.type === "private") {
        this.showGameModal = true;
        this.gameName = payload.game.name;
      } else {
        this.showPreviewDialog = true;
        // For public games, get the game type from the config
        if (payload.game.config && payload.game.config.type) {
          this.gameName = payload.game.config.type;
        } else {
          this.gameName = payload.game.name;
        }
      }
      this.$forceUpdate();
    });
    // Bus.$on("show-preview-dialog", (payload) => {
    //   console.log(payload, "payload");
    //   this.showPreviewDialog = true;
    //   this.gameName = payload.game.name;
    //   this.$forceUpdate();
    // });

    Bus.$on("showMe", (value) => {
      if (this.data?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 3000);
      }
    });
    // Bus.$on("showPreviewer", (value) => {
    //   if (this.data?.photo?.previewerQr?.previewer?.gif) {
    //     this.showPreviewer = true;
    //     this.locationPage = false;
    //     this.showWelcome = false;

    //     setTimeout(() => {
    //       this.locationPage = false;
    //       // this.showPreviewer = false;
    //       this.showWelcome = false;
    //     }, 3000);
    //   }
    // });

    setTimeout(() => this.setKeys(this.data), 200);
    this.$root.$on("visit-data-updated", (payload) => {
      if (payload.data.lang === this.currentLang) return;

      // if (payload.data.lang !== this.currentLang) {
      //   if (this.$options.name === "mobileViwer") {
      //     const theme = payload.data.theme;
      //     if (theme === "mobileviewer" || !theme) {
      //       this.data = payload.data.data;
      //       this.$forceUpdate();
      //     }
      //   } else {
      //     this.data = payload.data.data;
      //     this.$forceUpdate();
      //   }
      // }

      this.data = payload.data.data;
      // this.orders = payload.orders;

      // this.theme = payload.data.theme;
      this.$forceUpdate();
    });
    this.ensureDefaults();
    this.changeLanguage(this.defaultLang);
    this.$forceUpdate();
  },

  beforeDestroy() {
    this.$root.$off("fetchDragList");
    this.$root.$off("card-lang-reset");
    this.$root.$off("mobile-viewer-lang-change");
    Bus.$off("preview-game-in-mobile");
    Bus.$off("open-game-modal");
    Bus.$off("showMe");
    Bus.$off("showPreviewer");
  },

  methods: {
    ...mapActions("localstorage", [
      "setDraggingKeysOrder",
      "setLangList",
      "setDefaultLang",
      "setCurrentLanguage",
    ]),
    isDirectVideo(url) {
    if (!url) return false;
    return /\.(mp4|webm|ogg)$/i.test(url.trim());
  },
  isBigSvg(svg) {
    const list = [
      'svgdigikala',
      'svgbasalam',
      'svgsnappshop',
      'svgtechnolife',
      'svgtorob',
      'svgemalls',
      'svgrubika',
      'svgwhatsapp',
      'svgbale',
      'svgeitaa',
      'svgsoroush',
      'svgtelegram',
      'svgviber',
      'svgwechat',
      'svgsheypour',
      'svgdivar',
      'svgaparat',
      'svggap'
    ];
    return list.includes((svg || '').toLowerCase());
  },
    onPreviewGameOver(score) {
      console.log("Preview game over, score:", score);
    },
    onGameScoreSubmit(data) {
      this.$emit("game-score-submit", data);
    },
    showPreview() {
      this.previewKey = Date.now();
      this.showPreviewDialog = true;
    },
    getTextDirectionFromContent(text) {
      if (!text || typeof text !== "string") {
        return this.currentTextDirection;
      }
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return detectLanguage(text, fallbackLang);
    },
    getTextAlignFromContent(text) {
      if (!text || typeof text !== "string") {
        return this.isCurrentLangRTL ? "right" : "left";
      }
      const fallbackLang =
        this.currentLang || this.defaultLang || this.$i18n?.locale || "fa";
      return getTextAlign(text, fallbackLang);
    },

    ensureDefaults() {
      if (!this.data) return;
      // pallete
      if (!this.data.pallete) {
        this.data.pallete = {
          headColor: "linear-gradient(to top, #AA7630FF, #EBCB63FF)",
          bodyColor: "linear-gradient(to top right, #AA7630FF, #EBCB63FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        };
      }
      // photo
      if (!this.data.photo) this.data.photo = {};
      // if (!this.data.photo.headBackground) {
      //   this.data.photo.headBackground =
      //     "/media/defaults/visitFirstDefault.webp";
      // }
      if (!this.data.photo.transition) {
        this.data.photo.transition = "scale";
      }
      // langs
      if (!this.data.langs) {
        this.data.langs = { source_lang: "fa", other_langs: [] };
      }
    },

    internalLangChange(lang) {
      // if (lang === this.currentLang) {
      //   return;
      // }
      this.$root.isTranslating = true;
      this.changeLanguage(lang);

      this.showLangSwitcher = false;
    },

    syncInitialLang() {
      // if (this.data.langs?.other_langs?.length > 0) {
      //   const firstLang = this.data.langs.other_langs[0].lang;
      //   this.changeLanguage(firstLang);
      // } else {
      this.changeLanguage(
        this.sourceLanguage || this.defaultLang || this.$i18n.locale,
      );
      // }
    },

    changeLanguage(newLang) {
      if (!newLang || newLang === this.currentLang) {
        this.$root.isTranslating = false;
        return;
      }
      const selectlang =
        typeof newLang === "string"
          ? newLang
          : (Array.isArray(newLang) ? newLang[0] : newLang)?.lang || "fa";
      if (!selectlang) {
        this.$root.isTranslating = false;
        return;
      }
      this.$root.isTranslating = true;

      if (selectlang === this.defaultLang) {
        this.data = this.mainDatalang.data.data;
        this.localI18n.locale = selectlang;
        this.$root.isTranslating = false;
      } else {
        this.$root.isTranslating = true;
        this.$api
          .get(`/langData?id=${this.createQrID}&lang=${selectlang}`)
          .then((res) => {
            const receivedData = res.data.data.data;
            const receivedTheme = res.data.data.theme;

            // if (this.$options.name === "mobileViwer") {
            //   if (receivedTheme === "mobileviewer" || !receivedTheme) {
            //     this.data = receivedData;
            //   }
            // } else {
            //   this.data = receivedData;
            // }

            this.$emit("input", receivedData);

            this.$root.$emit("mobile-viewer-updated", {
              // orders: res.data.data.orders,
              theme: res.data.data.theme,
              data: receivedData,
              lang: newLang,
            });

            this.setCurrentLanguage(selectlang);
            this.applyLangData(newLang, receivedData);
            this.$emit("input", res.data.data.data);

            this.$root.$emit("mobile-viewer-updated", {
              // orders: res.data.data.orders,
              theme: res.data.data.theme,
              data: res.data.data.data,
              lang: newLang,
            });
            //this.$root.$emit("mobile-viewer-lang-change", selectlang);
            this.setCurrentLanguage(selectlang);

            //new change
            this.data = res.data.data.data;
            // this.theme = res.data.data.theme;
            // this.orders = res.data.data.orders;
            //  this.langDataCache[newLang] = data;

            this.applyLangData(newLang, this.data);
          })
          .catch(() => {
            this.$root.isTranslating = false;
            //   this.changeLanguage(this.sourceLanguage);
          })
          .finally(() => (this.$root.isTranslating = false));
      }
    },

    applyLangData(lang, data) {
      this.data = { ...data };
      this.ensureDefaults();
      this.currentLang = lang;
      this.localI18n.locale = lang;

      // this.cacheCurrentData();
    },

    // cacheCurrentData() {
    //   this.langDataCache[this.currentLang] = { ...this.data };
    // },

    show() {
      this.showconncet = !this.showconncet;
      Bus.$emit("showconnect", this.showconncet);
    },

    getAudioById(itemId) {
      const index = parseInt(itemId.replace("audio_", ""));
      return this.data?.audiosGallery?.audios?.[index] || {};
    },

    openMap() {
      let agent = window.navigator.userAgent;
      let type = "https://www.google.com/maps/@";

      if (agent.toLowerCase().search("android") > 0) {
        type = "geo:";
      } else if (
        agent.search("iPad") > 0 ||
        agent.search("iPhone") > 0 ||
        agent.search("iPod") > 0
      ) {
        type = "maps:";
      }

      window.open(
        `${type}${this.data.coordinates[1]},${this.data.coordinates[0]}?q=${this.data.coordinates[1]},${this.data.coordinates[0]}`,
        "_blank",
      );
    },

    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },

    getlatLng() {
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.data.coordinates[1],
          lon: this.data.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.data.address = response.data.address;
        })
        .finally(() => (this.locLoading = false));
    },

    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        companyNumberName: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.data[x];
      });

      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a");
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data;
          a.download = `${info.userName}.vcf`;
          a.click();
        })
        .finally(() => (this.vcfLoading = false));
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },

    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },

    fixOrders(val) {
      const keys = Object.keys(val);
      const mapOrder = this.draggingKeys.map((item) => item.name);
      const result = keys.filter((item) => mapOrder.includes(item));
      const sortedKeys = result.sort(
        (a, b) => mapOrder.indexOf(a) - mapOrder.indexOf(b),
      );
      this.draggingKeys = sortedKeys.map((item) => ({ name: item }));
    },

    setKeys(val = this.data) {
      let keys = setDragging(val, this.draggingKeys);

      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );

      this.draggingKeys = keys;
    },
  },
};
</script>

<style scoped>
.mainBox {
  min-height: 400px;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  position: relative;
}

.headBox {
  overflow: hidden;
  position: relative;
  background-size: cover !important;
  background-position: top !important;
  background-repeat: no-repeat;
  border-radius: 10px;
}

.headBox > * {
  position: relative;
  z-index: 1;
}

.headBox.has-bg-head:before {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.1) 20%,
    rgba(0, 0, 0, 0.35)
  );
  z-index: 0;
}

.header-img-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 2px solid white;
  position: relative;
  overflow: hidden;
  margin: auto;
}

.header-img-bg >>> .bg-filter {
  position: absolute;
  inset: -4px;
  background-size: cover;
  filter: blur(1.8px) brightness(1.3) opacity(0.8);
}

.header-img-bg >>> img {
  position: relative;
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
}

.footerBox {
  bottom: -1rem;
  right: 0;
  left: 0;
  z-index: 20;
  border-radius: 10px;
}

.callBox {
  border-radius: 10px;
}

.btnBox {
  background-color: #f3f5f9;
  border-radius: 8px;
}

.clickable {
  cursor: pointer;
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

iframe {
  border: none;
  border-radius: 8px;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
.mainBox[dir="rtl"] {
  direction: rtl;
}

.mainBox[dir="ltr"] {
  direction: ltr;
}
.box{
  width: 98% !important;
}
.qr-floating-btn {
  position: absolute;
  top: 13px;
  left: 15px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
